<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left>
      <vdr-language-selector
        [availableLanguageCodes]="availableLanguages$ | async"
        [currentLanguageCode]="contentLanguage$ | async"
        (languageCodeChange)="setLanguage($event)"
      ></vdr-language-selector>
    </vdr-ab-left>
    <vdr-ab-right>
      <vdr-action-bar-items
        [locationId]="'notice-table'"
      ></vdr-action-bar-items>
      <a class="button primary" [routerLink]="['/extensions/notice/create']">{{
        "notice.createNew" | translate
      }}</a>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>
<vdr-data-table-2
  class="mt-2"
  id="notice-table"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-bulk-action-menu
    locationId="notice-table"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  ></vdr-bulk-action-menu>
  <!-- <vdr-dt2-search
    [searchTermControl]="searchTermControl"
    [searchTermPlaceholder]="'Search shop supplier by Name'"
  /> -->
  <vdr-dt2-column
    [heading]="'common.id' | translate"
    id="id"
    [hiddenByDefault]="false"
    [sort]="sort.get('id')"
  >
    <ng-template let-notice="item">
      {{ notice.id }}
    </ng-template> 
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'notice.title' | translate"
    id="title"
    [hiddenByDefault]="false"
    [sort]="sort.get('nTitle')"
  >
    <ng-template let-notice="item">
      <a class="button-ghost" [routerLink]="['/extensions/notice', notice.id]"
        ><span> {{ notice.nTitle }}</span
        ><clr-icon shape="arrow right"
      /></a>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'notice.writer' | translate"
    id="writer"
    [hiddenByDefault]="false"
  >
    <ng-template let-notice="item">
      {{ notice.nWriter }}
    </ng-template>
  </vdr-dt2-column>

  <!-- <vdr-dt2-column
    [heading]="'notice.platform' | translate"
    id="platform"
    [hiddenByDefault]="false"
  >
    <ng-template let-notice="item">
      {{ notice.platform }}
    </ng-template>
  </vdr-dt2-column> -->

  <vdr-dt2-column
    [heading]="'common.createdAt' | translate"
    id="createdAt"
    [hiddenByDefault]="false"
    [sort]="sort.get('createdAt')"
  >
    <ng-template let-notice="item">
      {{ notice.createdAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.type' | translate"
    id="type"
    [hiddenByDefault]="true"
  >
    <ng-template let-notice="item">
      {{ notice.type }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.updatedAt' | translate"
    id="updatedAt"
    [hiddenByDefault]="false"
    [sort]="sort.get('updatedAt')"
  >
    <ng-template let-notice="item">
      {{ notice.updatedAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
